import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export default class PicoLEDNode extends BaseNode {
    constructor() {
        super();
        this.name = 'LED';
        this.id = 'node_pico_led';
        this.icon = 'VscDebugConsole';
        this.linkedFeature = 'general';
        this.requirements = ['RPPICOW'];

        this.inputs = [
            {
                name: 'state',
                portId: 'ledState',
                params: [
                ],
            },
        ];

        this.settings = this.settings.concat([
            {
                id: 'STATE',
                name: 'LED state',
                settingType: SettingType.OPTION,
                required: true,
                default: 'OFF',
                options: [
                    {
                        name: 'OFF',
                        value: 'OFF',
                    },
                    {
                        name: 'ON',
                        value: 'ON',
                    },
                ],
            },
        ]);
    }

    getSettingValue(settingId: string): string {
        if (settingId === 'DISPLAY_NAME') {
            const value = super.getSettingValue(settingId);
            if (value !== '') {
                return value;
            }
            const state = this.getSettingValue('STATE');
            return `Set LED to ${state}`;
        }
        return super.getSettingValue(settingId);
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;

        const links = project.getNodeLinks(this, 'ledState');
        const doneLinks = project.getNodeLinks(this, 'done');
        const doneBlock = doneLinks.length > 0 ? `#****${doneLinks[0].getSourceId()}****#` : '';

        for (let i = 0; i < links.length; i += 1) {
            const link = links[i];
            const state = this.getSettingValue('STATE');

            blocks.push({
                location: link.getSourceId(),
                blockType: BlockType.CODE,
                id: link.getID(),
                template: `
led = machine.Pin("LED", machine.Pin.OUT)
${state === 'OFF' ? 'led.off()' : 'led.on()'}
${doneBlock}`,
            });
        }

        return blocks;
    }
}
